import { useState } from "react";
import { MAX_TEXT_LENGTH } from "../lib/constants.js";
import styles from "./AddItemForm.module.css";

interface Props {
  onAdd: (text: string) => Promise<void>;
  onError?: (message: string) => void;
  disabled?: boolean;
}

export function AddItemForm({ onAdd, onError, disabled }: Props) {
  const [text, setText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = text.trim();
    if (!trimmed || submitting) return;

    setSubmitting(true);
    try {
      await onAdd(trimmed);
      setText("");
    } catch {
      onError?.("アイテムの追加に失敗しました。");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        maxLength={MAX_TEXT_LENGTH}
        placeholder="アイテムを追加…"
        disabled={disabled || submitting}
        autoFocus
        aria-label="新しいアイテム"
      />
      <button type="submit" disabled={!text.trim() || disabled || submitting}>
        追加
      </button>
    </form>
  );
}
